'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _merge = require('lodash/merge');

var _merge2 = _interopRequireDefault(_merge);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = function (_ref, _ref2) {
  var lineClamp = _ref.lineClamp,
      size = _ref.size,
      styles = _ref.styles;
  var measures = _ref2.measures,
      rhythm = _ref2.rhythm,
      scale = _ref2.scale,
      treatments = _ref2.treatments;

  var headingStyle = function headingStyle(size) {
    return _extends({}, treatments.head, {
      fontSize: scale(size),
      marginBottom: rhythm(1)
    });
  };

  var defaultStyles = _extends({
    fontSize: scale(size),
    lineHeight: measures.medium
  }, treatments.body, lineClamp && {
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    display: '-webkit-box',
    WebkitBoxOrient: 'vertical',
    WebkitLineClamp: lineClamp
  }, {

    '& p': {
      marginBottom: rhythm(1)
    },

    '& ul': {
      listStyleType: 'disc',
      listStylePosition: 'outside',
      marginBottom: rhythm(1)
    },

    '& ol': {
      listStyleType: 'decimal',
      listStylePosition: 'outside',
      marginBottom: rhythm(1)
    },

    '& li': {
      marginLeft: rhythm(1)
    },

    '& blockquote': {
      maxWidth: rhythm(25),
      marginBottom: rhythm(1),
      margin: '0 auto',
      textAlign: 'center',
      fontWeight: 700,
      fontSize: scale(size + 1)
    },
    '& blockquote:before': {
      content: '"open-quote"'
    },
    '& blockquote:after': {
      content: '"close-quote"'
    },

    '& img': {
      display: 'block',
      margin: '0 auto',
      width: 'auto',
      maxWidth: '100%'
    },

    '& iframe': {
      marginBottom: rhythm(2)
    },

    '& strong': {
      fontWeight: 700
    },

    '& em': {
      fontStyle: 'italic'
    },

    '& h1': _extends({}, headingStyle(size + 4)),
    '& h2': _extends({}, headingStyle(size + 3)),
    '& h3': _extends({}, headingStyle(size + 2)),
    '& h4': _extends({}, headingStyle(size + 1)),
    '& h5': _extends({}, headingStyle(size)),
    '& h6': _extends({}, headingStyle(size - 1)),

    '& > *:last-child': {
      marginBottom: 0
    }
  });

  return {
    root: (0, _merge2.default)(defaultStyles, styles)
  };
};


//////////////////
// WEBPACK FOOTER
// ../~/constructicon/rich-text/styles.js
// module id = 863
// module chunks = 0